import moment from 'moment';
import {
  GET_STORES_REQUEST,
  GET_STORES_SUCCESS,
  GET_STORES_FAILURE,
  GET_STORES_CACHED,
} from '../action/actionTypes';

const initialState = {
  payload: {},
  error: '',
  isWaiting: false,
  lastRefresh: null,
};

export default function stores(state = initialState, action) {
  switch (action.type) {
    case GET_STORES_REQUEST:
      return {
        ...state,
        isWaiting: true,
        error: initialState.error,
      };
    case GET_STORES_SUCCESS:
      return {
        ...state,
        payload: action.payload,
        isWaiting: false,
        lastRefresh: moment(),
        error: initialState.error,
      };
    case GET_STORES_FAILURE:
      return {
        ...state,
        error: action.error,
        isWaiting: false,
      };
    case GET_STORES_CACHED:
      return {
        ...state,
        isWaiting: false,
        error: initialState.error,
      };
    default:
      return state;
  }
}
